import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BrPageComponent } from '@bloomreach/ng-sdk';
import { Page } from '@bloomreach/spa-sdk';
import { SkiptoHeaderService } from '@services/skipto-header.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ft-one-col-accordion',
  templateUrl: './one-col-accordion.component.html',
  styleUrls: ['./one-col-accordion.component.scss'],
})
export class OneColAccordionComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @Input() numberOfAccordionItems;
  @Input() page!: Page;

  configuration: BrPageComponent['configuration'];
  accordionItems;
  accordionLabels: Array<string> = [];

  @ViewChild('mainContent') mainContent: ElementRef;
  private skipToSubscription: Subscription;

  constructor(private skipToHeaderService: SkiptoHeaderService) {
    this.accordionItems = Array(this.numberOfAccordionItems).fill(
      this.numberOfAccordionItems
    );
  }
  ngOnInit(): void {
    this.accordionItems = this.page?.getComponent('accordion-item-1')
      ? Array(this.numberOfAccordionItems).fill(this.numberOfAccordionItems)
      : [];

    this.generateAccordionLabel();
  }

  generateAccordionLabel(): void {
    this.accordionItems.forEach((element, index) => {
      const accordionArea = this.page.getComponent(
        `accordion-item-${index + 1}`
      );
      const label = accordionArea?.getComponent('accordion-label')?.getModels()
        ?.AccordionLabel?.label;
      this.accordionLabels.push(label);
    });
  }

  /**
   * Page loaded
   */
  public ngAfterViewInit(): void {
    // Subscribe to the boolean value emitted by skipToHeaderService
    this.skipToSubscription = this.skipToHeaderService
      .getSkipToHeaderBoolean$()
      // Filter out falsy values emitted by skipToHeaderService
      .pipe(filter((skipTo) => skipTo))
      // Perform the focus and scrollIntoView actions when a truthy value is emitted by skipToHeaderService
      .subscribe(() => {
        this.skipToHeaderService.scrollToMainContent(this.mainContent);
      });
  }
  public ngOnDestroy(): void {
    // Unsubscribe from the subscription when the component is destroyed
    this.skipToSubscription?.unsubscribe();
  }
}
